import { ServerFilterableQueue } from "../components/ServerFilterableQueue";
import { TabHeading } from "../components/tab-states";
import { useBadges } from "../data/queries";

/** The queue of proposals the machine deliberately did NOT recommend. */
export function DeferTab() {
  const badges = useBadges();
  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Defer-to-human"
        description="Proposals the machine deliberately did not recommend, because it is not confident enough to call them. You are making the decision, not confirming one. Where it is confident, the proposal goes to the Review queue instead."
        aside={badges.data ? `${badges.data.defer} waiting` : undefined}
      />
      <ServerFilterableQueue
        scope="defer"
        showStatusFilter
        defaultStatus="proposed"
        emptyTitle="No proposals waiting."
        errorTitle="Could not load the defer queue"
      />
    </div>
  );
}
